import React from 'react';

class ClearLsErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { error: null, errorInfo: null };
    }

    componentDidCatch(error, errorInfo) {
        this.setState({
            error: error,
            errorInfo: errorInfo
        })
    }

    render() {
        //Error
        if (this.state.errorInfo) {
            localStorage.clear();
            // Error path
            return null
        }
        //Normal
        return this.props.children;
    }
}

export default ClearLsErrorBoundary;